(() => {
  function showMedia(root, mediaId) {
    if (!mediaId) return;
    const panels = [...root.querySelectorAll('[data-media-id]')];
    if (!panels.some(panel => panel.dataset.mediaId === mediaId)) return;
    panels.forEach(panel => {
      const active = panel.dataset.mediaId === mediaId;
      panel.hidden = !active;
      if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    root.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      const active = button.dataset.galleryThumb === mediaId;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  function initProduct(root) {
    if (root.dataset.babyReady === 'true') return;
    root.dataset.babyReady = 'true';
    const form = root.querySelector('.baby-product__form');
    if (!form) return;
    const quantity = form.querySelector('[name="quantity"]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const buyLinks = [...root.querySelectorAll('[data-buy-now]')];
    const money = new Intl.NumberFormat(root.dataset.moneyLocale || 'en', {
      style: 'currency', currency: root.dataset.currency, currencyDisplay: 'narrowSymbol'
    });

    function renderPurchase() {
      const selected = variantSelect.selectedOptions[0];
      if (!selected) return;
      const count = Math.max(1, Math.floor(Number(quantity.value) || 1));
      quantity.value = String(count);
      const price = Number(selected.dataset.priceAmount);
      const former = Number(selected.dataset.compareAmount);
      const total = count === 1 ? selected.dataset.price : money.format(price * count / 100);
      const formerTotal = former > price ? (count === 1 ? selected.dataset.compare : money.format(former * count / 100)) : '';
      root.querySelector('[data-price]').textContent = total;
      root.querySelector('[data-mobile-price]').textContent = total;
      root.querySelector('[data-compare-price]').textContent = formerTotal;
      root.querySelector('[data-former-price]').hidden = !formerTotal;
      const mobileFormer = root.querySelector('[data-mobile-compare]');
      mobileFormer.textContent = formerTotal;
      mobileFormer.hidden = !formerTotal;
      root.querySelector('[data-selection-summary]').textContent = `${count} × ${selected.textContent}`;
      root.querySelector('[data-mobile-variant]').textContent = `${count} × ${selected.textContent}`;
      const available = selected.dataset.available === 'true';
      buyLinks.forEach(link => {
        link.href = `${root.dataset.cartUrl}/${selected.value}:${count}`;
        link.setAttribute('aria-disabled', String(!available));
        link.querySelector('[data-buy-label]').textContent = available ? 'Buy now' : 'Sold out';
      });
    }

    function syncPackage() {
      root.querySelectorAll('[data-package-card]').forEach(card => {
        const active = card.dataset.packageCard === variantSelect.value;
        card.classList.toggle('is-selected', active);
        const button = card.querySelector('[data-package]');
        button.setAttribute('aria-pressed', String(active));
        button.textContent = active ? 'Selected package' : `Choose ${card.dataset.variantTitle}`;
      });
    }

    root.querySelectorAll('[data-package]').forEach(button => {
      button.addEventListener('click', () => {
        variantSelect.value = button.dataset.package;
        quantity.value = '1';
        variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        root.querySelector('#product-purchase')?.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });

    root.querySelectorAll('[data-variant-option]').forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantSelect.value = radio.value;
        quantity.value = '1';
        variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
      });
    });

    root.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      button.addEventListener('click', () => showMedia(root, button.dataset.galleryThumb));
    });

    const lightbox = root.querySelector('[data-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const galleryImages = [...root.querySelectorAll('[data-full-image]')];
    let lightboxIndex = 0;

    function showLightboxImage(index) {
      lightboxIndex = (index + galleryImages.length) % galleryImages.length;
      const source = galleryImages[lightboxIndex];
      lightboxImage.src = source.dataset.fullImage;
      lightboxImage.alt = source.querySelector('img')?.alt || 'Product image';
      lightbox.querySelector('[data-lightbox-count]').textContent = `${lightboxIndex + 1} / ${galleryImages.length}`;
      showMedia(root, source.dataset.lightboxMedia);
    }

    galleryImages.forEach((button, index) => {
      button.addEventListener('click', () => {
        showLightboxImage(index);
        lightbox.showModal();
      });
    });
    lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showLightboxImage(lightboxIndex - 1));
    lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showLightboxImage(lightboxIndex + 1));
    lightbox?.addEventListener('click', event => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') showLightboxImage(lightboxIndex - 1);
      if (event.key === 'ArrowRight') showLightboxImage(lightboxIndex + 1);
    });
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number.parseInt(quantity.value, 10) - 1 || 1));
      renderPurchase();
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number.parseInt(quantity.value, 10) || 1) + 1);
      renderPurchase();
    });
    quantity?.addEventListener('change', () => {
      renderPurchase();
    });

    variantSelect?.addEventListener('change', () => {
      const selected = variantSelect.selectedOptions[0];
      if (!selected) return;
      root.querySelectorAll('[data-variant-option]').forEach(radio => {
        radio.checked = radio.value === selected.value;
        radio.closest('.baby-product__option').classList.toggle('is-selected', radio.checked);
      });
      syncPackage();
      renderPurchase();
      showMedia(root, selected.dataset.mediaId);
      if (window.location.protocol === 'http:' || window.location.protocol === 'https:') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url);
      }
    });

    buyLinks.forEach(link => link.addEventListener('click', event => {
      renderPurchase();
      if (link.getAttribute('aria-disabled') === 'true' || root.dataset.checkoutPending === 'true') {
        event.preventDefault();
        return;
      }
      // A cart permalink specifies exact quantities; it never adds to an existing line.
      if (!event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        root.dataset.checkoutPending = 'true';
      }
    }));
    window.addEventListener('pageshow', () => {
      root.dataset.checkoutPending = 'false';
      renderPurchase();
    });
    renderPurchase();
  }

  document.querySelectorAll('[data-baby-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-baby-product]').forEach(initProduct);
  });
})();
